import React from "react";
import {Alert, Button, Flex, Text} from "@aws-amplify/ui-react";
import {Link, useLoaderData} from "react-router-dom";
import styles from './index.module.css';

const LicenseWarning = ({isInCourse = false}) => {
  const {license_is_active} = useLoaderData();

  return !license_is_active &&
    (
      <Alert
        padding="32px"
        hasIcon={false}
        variation="warning"
        isDismissible={false}
        className={styles.alertWrapper}
        heading="Attenzione! La tua licenza è scaduta"
      >
        <Flex
          direction="column"
          alignSelf="center"
          justifyContent="center"
        >
            {
              isInCourse ?
                <Text>
                  I contenuti di lezioni e approfondimenti di questo corso non saranno disponibili integralmente.
                  Contatta l'Ufficio Assistenza per maggiori informazioni
                </Text> :
                <Text>
                  Stai attualmente visualizzando un'anteprima del contenuto.
                  Contatta l'Ufficio Assistenza per maggiori informazioni
                </Text>
            }
          <Link to="/assistenza">
            <Button
              isFullWidth
              className={styles.ctaBtn}
            >
              Contatta l'assistenza
            </Button>
          </Link>
        </Flex>
      </Alert>
    )
}

export default LicenseWarning;